// extracted by mini-css-extract-plugin
module.exports = {"horizontalRate":"questionTypes_horizontalRate__3_4XC","horizontalRateValue":"questionTypes_horizontalRateValue__YpQ4z"};